import React, { useEffect, useImperativeHandle, useState } from 'react';
import './profile-form.sass';
import { Input } from '../../../../components/interface/input/input';
import * as Yup from 'yup';
import { TextArea } from '../../../../components/interface/input/textarea/textarea';
import { useFormik } from 'formik';
import { Dropdown } from '../../../../components/interface/input/dropdown/dropdown';
import { useDispatch, useSelector } from 'react-redux';
import { createProfile } from '../../configuration.slice';
import { unwrapResult } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import {getTeamVendorId, getVendor} from '../../../login/session.slice';
import {
    DashboardProfileImageUpload
} from '../../../dashboard/profile/components/image-upload/dashboard-profile-image-upload';
import { getCategories } from '../../../dashboard/profile/dashboard-profile.slice';
import { InputCheckbox } from '../../../../components/interface/input/checkbox/input-checkbox';

const FormSchema = Yup.object().shape({
    name: Yup.string().min(3, 'Za mało!').max(25).required('Pole wymagane!'),
    category: Yup.string(),
    url: Yup.string().url('Podaj poprawny url!').required('Podaj poprawny url!'),
    address: Yup.string().required('Pole wymagane!'),
    description: Yup.string().max(200, 'Za dużo!').required('Pole wymagane!'),
    regulations: Yup.boolean().oneOf([true], 'Pole wymagane'),
});
/* eslint-disable react/display-name */
export const ProfileForm = React.forwardRef(({onSuccess}, ref) => {

    const dispatch = useDispatch();
    const sessionData = useSelector(state => state.session);

    const vendorId = getTeamVendorId(sessionData);
    const vendor = getVendor(sessionData);
    const categories = useSelector(state => state.dashboardProfile.categories);

    useEffect(() => {
        dispatch(getCategories({}));
    }, []);

    const startFn = () => {
        formik.submitForm();
    };

    useEffect(() => {
        if (ref) {
            ref.current = { start: startFn };
        }
    }, [ref]);

    useImperativeHandle(ref, () => ({
        start:  startFn
    }));

    const formik = useFormik({
         initialValues: {
            id: vendorId,
            name: '',
            category: '',
            url: 'https://',
            address: '',
            description: '',
            regulations: false
        },
        validationSchema: FormSchema,
        onSubmit: (values) => {
            dispatch(createProfile(values))
                .then(unwrapResult)
                .then(() => {
                    toast.success('formularz wysłany');
                    onSuccess();
                }, () => {
                    toast.error('coś poszło nie tak');
                })
                .catch(e => {
                    toast.error(e.message);
                });
        }
    });

    return (
        <div ref={ref} className='vv-vendor-profile-form-container'>
            <form onSubmit={formik.handleSubmit}>
                <div className='vv-vendor-profile-form'>
                    <div className='vv-vendor-profile-form__input-container'>
                        <div className='vv-vendor-profile-form__input-margin'>
                            <Input label='Nazwa' onBlur={formik.handleBlur} onChange={formik.handleChange}
                                   name='name' id='name'
                                   value={formik.values.name}
                                   textError={formik.touched.name && formik.errors.name}/>
                        </div>
                        <div className='vv-vendor-profile-form__input-margin'>
                            <Dropdown name='category' id='category' label='Branża'
                                      value={formik.values.category}
                                      onBlur={formik.handleBlur} onChange={(option) => formik.setFieldValue('category', option.value)}
                                      options={categories.map((category) => ({value: category.id, label: category.label}))}/>
                        </div>
                        <div className='vv-vendor-profile-form__input-margin'>
                            <Input label='Link do strony' onBlur={formik.handleBlur} onChange={formik.handleChange}
                                   name='url' id='url'
                                   value={formik.values.url}
                                   textError={formik.touched.url && formik.errors.url}/>
                        </div>
                        <div className='vv-vendor-profile-form__input-margin'>
                            <Input label='Lokalizacja' onBlur={formik.handleBlur} onChange={formik.handleChange}
                                   name='address' id='address'
                                   value={formik.values.address}
                                   textError={formik.touched.address && formik.errors.address}/>
                            </div>
                            <InputCheckbox name='regulations' id='regulations'
                                           onChange={formik.handleChange}
                                           value={formik.values.regulations}
                                           labelComponent={<span>Oświadczam, iż zapoznałem/am się z treścią <a rel='noreferrer' target='_blank' href={'https://s3.eu-central-1.amazonaws.com/www.viceversa.app/regulation/regulation.pdf'} style={{ color: 'blue', textDecoration: 'underline' }}>Regulaminu</a> i akceptuję wszystkie zawarte w nim warunki.</span>}
                                           textError={formik.touched.regulations && formik.errors.regulations}/>
                    </div>
                    <div className='vv-vendor-profile-form__text-area-container'>
                        <div className='vv-vendor-profile-form__text-area-margin'>
                            <TextArea label='Opis twojej działalności'
                                      name='description' id='description'
                                      value={formik.values.description}
                                      onBlur={formik.handleBlur} onChange={formik.handleChange}
                                      textError={formik.touched.description && formik.errors.description}/>
                        </div>
                    </div>
                </div>
            </form>
            <div className='vv-vendor-profile-form__photo-container'>
                {
                    vendor?.photos.map((photo, i) => {
                        let profile = false;
                        if (photo.id.toString() === vendor?.main_photo?.id) {
                            profile = true;
                        }
                        return  <div key={i} className='photo-margin-right'>
                                    <DashboardProfileImageUpload img={photo.image_url} id={photo.id} isProfile={profile}/>
                                </div>;
                    })
                }
                {
                    vendor?.photos.length < 4 ?
                        <DashboardProfileImageUpload/>
                        : null
                }
            </div>
        </div>
    );
});
